import { flatttenGroups } from '../../utils/objectUtils';

export const allMessagesSelector = () => state => flatttenGroups(state.messages);

export const reportMessagesSelector = (reportKey) => state => reportKey ? state.messages[reportKey] : null;
